<adm-loading-spinner [loadingSignal]="loading()" [hasNoData]="loading()"></adm-loading-spinner>
@if (!isCustomerEntranceDialog()) {
  <h5>Afdelinger</h5>
}
<table #sort="matSort" #departmentList mat-table matSort (matSortChange)="refreshDetails()">
  <ng-container matColumnDef="departmentName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="DepartmentName">Afdelingsnavn</th>
    <td mat-cell *matCellDef="let department" class="row">
      @if (isCustomerEntranceDialog()) {
        <button type="button" (click)="onDepartmentClick(department)" class="department-link">
          {{ department.departmentName }}
        </button>
      } @else {
        {{ department.departmentName }}
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="departmentGroup">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="DepartmentGroup">Gruppe</th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.departmentGroupName }}</td>
  </ng-container>
  <ng-container matColumnDef="departmentLocationCount">
    <th mat-header-cell *matHeaderCellDef>Lokationer tilknyttet</th>
    <td mat-cell *matCellDef="let department" class="row">
      <a
        [routerLink]="['/locations']"
        class="blue"
        (click)="onDepartmentLinkNavigate()"
        [queryParams]="{ organizationId: organization().id, departmentId: department.departmentId }">
        {{ department.locationCount }}
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="idTagCount">
    <th mat-header-cell *matHeaderCellDef>Aktive brikker *</th>
    <td mat-cell *matCellDef="let department" class="row">
      <a
        [routerLink]="['/id-tags']"
        class="blue"
        (click)="onDepartmentLinkNavigate()"
        [queryParams]="{ organizationId: organization().id, departmentId: department.departmentId, idTagStatus: idTagStatusEnum.Active }">
        {{ department.idTagCount }}
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="accountNumber">
    <th mat-header-cell *matHeaderCellDef>
      <div class="icon-with-text">
        <span>G4 Kontonr.</span>
        <span class="outlined margin--left-s cursor-pointer" [matTooltip]="g4Info">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        </span>
      </div>
    </th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.invoicingAccountNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="agreementNumber">
    <th mat-header-cell *matHeaderCellDef>
      <div class="icon-with-text">
        <span>G4 Aftalenr.</span>
        <span class="outlined margin--left-s cursor-pointer" [matTooltip]="okAftaleNr">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        </span>
      </div>
    </th>
    <td mat-cell *matCellDef="let department" class="row">{{ department.agreementNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let department">
      <button
        class="action-button"
        [admRequiresFeatureRole]="roles['organization.write']"
        mat-icon-button
        [matMenuTriggerFor]="contextMenu"
        aria-label="Handlinger">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #contextMenu="matMenu">
        <button
          mat-menu-item
          (click)="openCreateLocationDialog(department.departmentId)"
          [admRequiresFeatureRole]="roles['charging-station-location.write']">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
          <span>Opret ny lokation</span>
        </button>

        <button
          mat-menu-item
          (click)="openUpdateDepartmentDialog(department.departmentId)"
          [admRequiresFeatureRole]="roles['department.write']">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
          <span>Redigér afdeling</span>
        </button>
        <button mat-menu-item (click)="openDownloadReportDialog(department.departmentId, department.departmentGroupName)">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
          <span>Download rapport</span>
        </button>
        <button
          mat-menu-item
          class="delete"
          (click)="openDeleteDepartmentDialog(department.departmentId, department.departmentName)"
          [admRequiresFeatureRole]="roles['department.write']">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
          <span>Slet afdeling</span>
        </button>
      </mat-menu>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
  <tr mat-row *matRowDef="let department; columns: displayColumns" [class.highlight]="department.highlight | async"></tr>
</table>

<p>* Tallet kan være misvisende hvis brikker er tilknyttet gennem en bruger og denne ikke har nogen tilknytning til en afdeling.</p>
